/**
 * A tag a touchpoint can be rolled up by. Each value is the customer_events
 * column the scope groups on (the single source of truth for group columns).
 */
export enum AttributionScope {
  CHANNEL = "channel",
  CAMPAIGN = "campaign_id",
  RECIPIENT = "recipient_id",
  AUTOMATION = "automation_id",
  AUTOMATION_STEP = "automation_step_id",
}
